import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

// DEFECT-D-05: shared by Staff.jsx and MemberDetail.jsx — suspending either a staff member or a
// member always requires a reason (never a silent status flip), and the confirming action here
// is what actually calls the reason-required `/suspend` endpoint.
export function SuspendDialog({ open, onOpenChange, onConfirm, isPending, entityLabel, testIds }) {
  const [reason, setReason] = useState("");

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setReason(""); }}>
      <DialogContent data-testid={testIds.suspendDialog} className="max-w-md">
        <DialogHeader>
          <DialogTitle>Suspend {entityLabel}</DialogTitle>
        </DialogHeader>
        <p className="text-sm" style={{ color: "var(--scarlet-text-secondary)" }}>
          Suspending immediately blocks their access — any active session ends right away. This is reversible anytime.
        </p>
        <Textarea
          data-testid={testIds.suspendReasonInput}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason for suspension (required)"
          rows={3}
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            data-testid={testIds.suspendConfirmButton}
            disabled={!reason.trim() || isPending}
            onClick={() => onConfirm(reason.trim())}
            className="text-white"
            style={{ background: "var(--scarlet-neg)" }}
          >
            Suspend
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
